import { Badge, type BadgeTone } from '../ui/badge';
import type { DialogState } from '../../api/types';

const LABELS: Record<DialogState, string> = {
  AGENT_ACTIVE: 'Агент',
  HUMAN_ACTIVE: 'Человек',
  CLOSED: 'Закрыт',
};

const TONES: Record<DialogState, BadgeTone> = {
  AGENT_ACTIVE: 'info',
  HUMAN_ACTIVE: 'warning',
  CLOSED: 'neutral',
};

export function StateBadge({ state }: { state: DialogState }) {
  return <Badge tone={TONES[state]}>{LABELS[state]}</Badge>;
}
